import { render, staticRenderFns } from "./CRMContractComplain.vue?vue&type=template&id=11304381&scoped=true&"
import script from "./CRMContractComplain.vue?vue&type=script&lang=js&"
export * from "./CRMContractComplain.vue?vue&type=script&lang=js&"
import style0 from "./CRMContractComplain.vue?vue&type=style&index=0&id=11304381&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11304381",
  null
  
)

export default component.exports